import { Route, Routes } from 'react-router-dom';
import './App.css';
import Blogs from './components/Blogs/Blogs';
import Details from './components/Details/Details';
import Home from './components/Home/Home';



function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />}></Route>
      <Route path="/blog" element={<Blogs />}></Route>
      <Route
        path="/service/:id"
        element={<Details></Details>}
      ></Route>
    </Routes>

  )
}

export default App;
